/** Parsed version of the josn string stored in letter_options > options table */
export class LobMailOptions
{
    isCertifiedMail = false;
    isBWMail = false;
    isColoredMail = false;
    isRegisteredMail = false;
    isStandardMail = false;
    isFirstClassMail = false;
    numPages = '';
    isOneSided = false;
    isTwoSided = false;

    /**
     * Request comes in as a json stringified; parse and assign here.
     * TODO phase 2 - this class goes away when the mail types are combined
     */
    constructor(request: string) {
        const options = JSON.parse(request);

        this.isCertifiedMail = options.is_certified_mail;
        this.isBWMail = !options.is_colored_mail;
        this.isColoredMail = options.is_colored_mail;
        this.isRegisteredMail = options.is_registered_mail;
        this.isStandardMail = options.is_standard_mail;
        this.isFirstClassMail = !options.is_standard_mail;
        this.numPages = !options.num_pages ? '' : (options.num_pages > 1
                ? options.num_pages + ' pages'
                : options.num_pages + ' page');
        this.isOneSided = !options.two_sided;
        this.isTwoSided = options.two_sided;
    }
}

/**
 * TODO - deprecate the above and clean how this works front end to back end, once this new type of lob unified mail goes live
 */
export class LobConsolidatedMailOptions
{
    sendTo: 'unit' | 'mailing' | '';
    tracking: 'certified' | 'registered' | '';
    mailClass: 'standard' | 'first class' | '';
    color: 'color' | 'bw' | '';

    doIncludeNoBalance = false;
    isDoubleSided = false;
    doIncludeFutureInvoices = false;
    doIncludeFutureOnly = false;
    includeUploadedPdfForEachUnit = false;

    constructor(request: LobConsolidatedMailOptions) {
        this.sendTo = request.sendTo;
        this.tracking = request.tracking;
        this.mailClass = request.mailClass;
        this.color = request.color;
        this.doIncludeNoBalance = request.doIncludeNoBalance;
        this.isDoubleSided = request.isDoubleSided;
        this.doIncludeFutureInvoices = request.doIncludeFutureInvoices;
        this.doIncludeFutureOnly = request.doIncludeFutureOnly;
        this.includeUploadedPdfForEachUnit = request.includeUploadedPdfForEachUnit;
    }
}
